var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChakra(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150px",
    height: "150px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M823.474259 64.209797l-329.153133 354.472604 329.153133 192.197809-630.876838 350.060878 329.153133-350.060878-329.153133-192.197809z",
    fill: "#47fff3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.610209 983.322606a22.381518 22.381518 0 0 1-16.316993-37.710668l309.898186-329.581517-304.879048-178.022741a22.378321 22.378321 0 0 1 0.322887-38.832781l630.876838-354.472604a22.381518 22.381518 0 0 1 27.362293 34.737548L529.726827 413.442677l305.029303 178.112254a22.381518 22.381518 0 0 1-0.425188 38.893522l-630.876838 350.060879a22.298398 22.298398 0 0 1-10.843895 2.813274z m45.006-564.266167l295.416216 172.498492a22.371927 22.371927 0 0 1 5.019138 34.654429l-230.912304 245.579694 471.105217-261.407561-295.208417-172.373813a22.381518 22.381518 0 0 1-5.115045-34.552128l231.858587-249.697305-472.163392 265.298192z",
    fill: "#ffffff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChakra);
export default __webpack_public_path__ + "static/media/chakra.25ee311f28fd1cd350f98a154e39ca52.svg";
export { ForwardRef as ReactComponent };